<template>
  <DModal
    :show-close="false"
    :isBgOverlay="true"
    @close="$emit('close')"
    :appendToBody="true"
    style="z-index: 12312312312312"
  >
    <div class="d-modal text-dark" id="d-add-calendar-to-cost-center" slot="insertComponent" @click.stop>
      <div class="d-modal__header">
        <h2>Vælg kalendere</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__content">
        <Tabs
          :tabs="tabs"
          :selected="activeTab"
          @select="activeTab = $event"
        />
        <table class="do-table do-table__items marg-1-top">
          <thead>
          <tr>
            <th>
              <p class="text-link" @click="toggleSelectAll">
                {{ isAllChecked ? 'Fravælg alle' : 'Vælg alle ' }}
              </p>
            </th>
            <th>Navn</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="calendar in filteredCalendars"
            :key="calendar.id"
            @click="toggleOne(calendar.id)"
            :class="{ 'row-selected': localSelectedIds.indexOf(calendar.id) > -1 }"
            style="cursor: pointer"
          >
            <td style="width: 80px">
              <input
                type="checkbox"
                :checked="localSelectedIds.indexOf(calendar.id) > -1"
                @click.stop="toggleOne(calendar.id)">
            </td>
            <td>{{ calendar.name }}</td>
          </tr>
          <tr v-if="filteredCalendars.length === 0">
            <td colspan="2"><i>Ingen kalendere</i></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="do-modal__buttons do-modal__buttons--end">
        <button class="do-bttn" @click="$emit('close')">
          {{ $t('vue2.common.cancel') }}
        </button>
        <button
          class="do-bttn do-bttn--submit"
          :class="{ 'do-bttn--submit--disabled': isSubmitting, 'do-bttn--submit--loading': isSubmitting }"
          @click="onSubmit"
        >
          Gem
        </button>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal.vue'
import Tabs from '../../common/Tabs.vue'

export default {
  components: {DModal, Tabs},
  props: {
    calendars: {
      type: Array,
      default: () => [] // [{ id, name, type? }]
    },
    selectedIds: {
      type: Array,
      default: () => []
    },
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localSelectedIds: [],
      activeTab: 'all'
    }
  },
  computed: {
    tabs () {
      // Hvis dine kalendere har en "type" prop med fx 'klass' | 'club' | 'other',
      // så viser vi tabs. Ellers bare 'all'.
      const hasType = this.calendars.some(c => c && c.type)
      if (!hasType) {
        return [{id: 'all', title: 'Alle'}]
      }
      return [
        {id: 'all', title: 'Alle'},
        {id: 'klass', title: 'Klasser'},
        {id: 'club', title: 'SFO'},
        {id: 'other', title: 'Andre'}
      ]
    },
    filteredCalendars () {
      if (this.activeTab === 'all') return this.calendars
      return this.calendars.filter(c => c.type === this.activeTab)
    },
    isAllChecked () {
      const idsInTab = this.filteredCalendars.map(c => c.id)
      if (idsInTab.length === 0) return false
      // alle i tab er valgt
      return idsInTab.every(id => this.localSelectedIds.indexOf(id) > -1)
    }
  },
  methods: {
    toggleOne (id) {
      const idx = this.localSelectedIds.indexOf(id)
      if (idx > -1) {
        this.localSelectedIds.splice(idx, 1)
      } else {
        this.localSelectedIds.push(id)
      }
    },
    toggleSelectAll () {
      const idsInTab = this.filteredCalendars.map(c => c.id)
      const allSelected = idsInTab.every(id => this.localSelectedIds.indexOf(id) > -1)
      if (allSelected) {
        // fjern alle i denne tab
        this.localSelectedIds = this.localSelectedIds.filter(id => idsInTab.indexOf(id) === -1)
      } else {
        // tilføj alle i denne tab
        const set = {}
        this.localSelectedIds.forEach(id => {
          set[id] = true
        })
        idsInTab.forEach(id => {
          set[id] = true
        })
        this.localSelectedIds = Object.keys(set).map(x => Number(x))
      }
    },
    onSubmit () {
      // lad parent afgøre om der er ændringer
      this.$emit('submit', this.localSelectedIds.slice())
      this.$store.dispatch('trackEvent', 'subSalary_CostCenterRules_saved')
    }
  },
  mounted () {
    this.localSelectedIds = Array.isArray(this.selectedIds) ? this.selectedIds.slice() : []
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  border-radius: 16px;
  position: relative;
  width: 800px;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
}

.d-modal__content {
  padding: 1rem 2rem 0;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  height: 800px;
}

.do-table__items {
  width: 100%
}

.do-table__items tr:hover {
  background: aliceblue;
}

.do-table__items tbody tr:not(:last-child) {
  border-bottom: 1px solid #eee;
}

.do-table__items th, .do-table__items td {
  padding: .5rem
}

.row-selected {
  background-color: aliceblue;
}

.do-modal__buttons--end {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
  padding: 1rem 2rem;
}
</style>



// WEBPACK FOOTER //
// CostCentersCenterCalendarsModal.vue?9616fcd4